/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";

import UseCases from "./components/UseCases"
// import AssetsMinted from "./components/AssetsMinted";
// import GasCalculator from "./components/GasCalculator";
import EmbedVideo from "./components/EmbedVideo";
import PoweredByLAOS from "./components/PoweredByLAOS";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import logo_eth from "../img/logo_eth.png";
import logo_pol from "../img/logo_polygon.png";
import logo_bin from "../img/logo_binance.png";
import logo_cron from "../img/logo_cronos.png";
import logo_op from "../img/logo_op.png";
import logo_arb from "../img/logo_arbitrum.png";
import logo_early from "../img/earlybird_logo_1.png";
import logo_target from "../img/target_global_logo_1.png";
import logo_adara from "../img/Adara_logo_1.png";
import logo_4F from "../img/4founders_logo_1.png";
import logo_polka from "../img/polkadot_parachain_logo.svg";
import benefit_icon_bridgeless from "../img/icon_bridgeless.png";
import benefit_icon_interop from "../img/icon_interop.png";
import benefit_icon_scale from "../img/icon_scalability.png";
import laos_sphere from "../img/laos-sphere.png";


// import roadmap from "../img/LAOS_ROADMAP.png";

const Home = () => {
  useEffect(() => {
    if (window.location.hash === "#community") {
      const element = document.getElementById("community");
      if (element) {
        element.scrollIntoView();
      }
    }
  }, []);

  const [copied, setCopied] = useState(false);

  const codeSnippet = `const headData = await api.query.paras.heads(3370);
const header = api.createType('Header', headData.unwrap());
console.log('LAOS block number:', header.number.toNumber());
console.log('LAOS parent hash:', header.parentHash.toHex());
console.log('LAOS state root:', header.stateRoot.toHex());`;

  const handleCopy = () => {
    navigator.clipboard.writeText(codeSnippet).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const [settings] = useState({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    slidesToScroll: 1,
    autoplay: true,
    speed: 5000,
    autoplaySpeed: 0,
    cssEase: "linear",
  });
  const logos = [logo_eth, logo_pol, logo_bin, logo_cron, logo_op, logo_arb];


  return (
    <>
      <div className="container mx-auto px-10 pb-0">
        {/* <!-- Hero --> */}
        <section>
          <div className="grid grid-cols-1 sm:grid-cols-3 place-items-center">
            <div className="col-span-2 pt-10 text-center sm:text-left">
              <h1 className="sm:w-3/4 pb-4 header-title text-3xl md:text-5xl leading-none lg:leading-tight">
                The Layer-1 to create millions of assets on Bitcoin and EVM chains</h1>
              <h2 className="sm:w-3/4 pb-10 header-title text-xl md:text-3xl leading-none lg:leading-tight">
                Mint <span className="text-fvyellow">100x cheaper</span> than any other blockchain</h2>
              <div className="grid grid-cols-1 md:w-100 md:flex md:space-x-4 space-y-4 md:space-y-0 md:justify-start">
                <a
                  href="https://docs.laosnetwork.io/"
                  className="border bg-fvyellow border-fvyellow text-fvpurple px-8 py-3 rounded transition duration-300 ease-in-out hover:bg-transparent hover:text-fvyellow"
                >
                  Documentation
                </a>
                <a
                  href="/foundation"
                  className="border border-fvyellow text-fvyellow px-8 py-3 rounded transition duration-300 ease-in-out hover:bg-fvyellow hover:text-fvpurple"
                >
                  ⚠️  LAOS Foundation Information  📁
                </a>
              </div>
            </div>
            <div className="">
              <img src={laos_sphere} alt="3D Ball" height="300" />
            </div>
          </div>
        </section>

        {/* URGENT CALL TO THE COMMUNITY */}
        <div className="max-w-5xl mx-auto mt-8 mb-4">
          <div className="border-2 border-red-500 bg-red-950/40 rounded-lg overflow-hidden shadow-lg shadow-red-900/30">

            {/* Header badge */}
            <div className="bg-red-600 px-5 py-3 flex items-center gap-3">
              <span className="text-2xl">🚨</span>
              <span className="text-white font-extrabold text-lg uppercase tracking-widest">
                Urgent Call to the Community
              </span>
              <span className="text-2xl">🚨</span>
            </div>

            <div className="px-5 py-4 space-y-4">

              {/* Positive fact */}
              <p className="font-semibold text-green-400 flex items-start gap-2">
                <span>✅</span>
                <span>A new community-maintained LAOS Public Node is needed in order for the LAOS blockchain to remain operational.</span>
              </p>

              {/* Urgent issue 1 */}
              <div className="border-l-4 border-orange-400 pl-4">
                <p className="font-bold text-orange-400 uppercase text-sm tracking-wide mb-1">
                  🔴 Critical
                </p>
                <p>
                  The <strong className="text-white">LAOS Public Node</strong> — used by{" "}
                  <a className="text-fvyellow hover:underline font-semibold" href="https://laos.statescan.io/" target="_blank" rel="noopener noreferrer">
                    Polkadot.js
                  </a>
                  , user wallets and by{" "}
                  <a className="text-fvyellow hover:underline font-semibold" href="https://laos.statescan.io/" target="_blank" rel="noopener noreferrer">
                    Statescan
                  </a>
                  {" "}to provide a public blockchain explorer — <strong className="text-orange-400">will be shut down</strong> on May 11th, 2026.
                  If the community does not run and maintain a replacement public node, it will be almost impossible to use the LAOS blockchain.
                  Should you have any questions, please <a className="text-fvyellow hover:underline font-semibold" href="https://github.com/freeverseio/laos/issues" target="_blank" rel="noopener noreferrer">open an issue</a>
                  {" "} in the LAOS GitHub repository.
                </p>
                <p className="text-orange-200">
                  The blockchain will still produce blocks as long as collators remain. Block inclusion in the Polkadot
                  relay chain can be checked in <a className="text-fvyellow hover:underline font-semibold" href="https://polkadot.js.org/apps/?rpc=wss%3A%2F%2Fpolkadot-rpc.publicnode.com#/js" target="_blank" rel="noopener noreferrer">Polkadot.js</a>,
                  by querying:
                </p>
                <div style={{
                  position: 'relative',
                  background: '#0d1117',
                  border: '1px solid #30363d',
                  borderRadius: '8px',
                  marginTop: '10px',
                  fontFamily: '"Fira Code", "Cascadia Code", "Consolas", monospace',
                  fontSize: '0.78rem',
                  lineHeight: '1.7',
                  overflow: 'hidden',
                }}>
                  {/* Header bar */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '6px 14px',
                    background: '#161b22',
                    borderBottom: '1px solid #30363d',
                  }}>
                    <span style={{ color: '#8b949e', fontSize: '0.7rem', letterSpacing: '0.05em', textTransform: 'uppercase' }}>JavaScript</span>
                    <button
                      onClick={handleCopy}
                      title={copied ? 'Copied!' : 'Copy to clipboard'}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        background: 'none',
                        border: '1px solid',
                        borderColor: copied ? '#3fb950' : '#30363d',
                        borderRadius: '5px',
                        padding: '3px 10px',
                        cursor: 'pointer',
                        color: copied ? '#3fb950' : '#8b949e',
                        fontSize: '0.7rem',
                        transition: 'all 0.2s',
                      }}
                    >
                      {copied ? (
                        <>
                          <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor"><path d="M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.75.75 0 0 1 1.06-1.06L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0z" /></svg>
                          Copied!
                        </>
                      ) : (
                        <>
                          <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor"><path d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z" /><path d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z" /></svg>
                          Copy
                        </>
                      )}
                    </button>
                  </div>
                  {/* Code lines */}
                  <pre style={{ margin: 0, padding: '14px 18px', overflowX: 'auto' }}><code>
                    <div><span style={{ color: '#ff7b72' }}>const</span><span style={{ color: '#e6edf3' }}> headData </span><span style={{ color: '#ff7b72' }}>=</span><span style={{ color: '#79c0ff' }}> await</span><span style={{ color: '#e6edf3' }}> api.query.paras.</span><span style={{ color: '#d2a8ff' }}>heads</span><span style={{ color: '#e6edf3' }}>(</span><span style={{ color: '#79c0ff' }}>3370</span><span style={{ color: '#e6edf3' }}>);</span></div>
                    <div><span style={{ color: '#ff7b72' }}>const</span><span style={{ color: '#e6edf3' }}> header </span><span style={{ color: '#ff7b72' }}>=</span><span style={{ color: '#e6edf3' }}> api.</span><span style={{ color: '#d2a8ff' }}>createType</span><span style={{ color: '#e6edf3' }}>(</span><span style={{ color: '#a5d6ff' }}>&apos;Header&apos;</span><span style={{ color: '#e6edf3' }}>, headData.</span><span style={{ color: '#d2a8ff' }}>unwrap</span><span style={{ color: '#e6edf3' }}>());</span></div>
                    <div><span style={{ color: '#e6edf3' }}>console.</span><span style={{ color: '#d2a8ff' }}>log</span><span style={{ color: '#e6edf3' }}>(</span><span style={{ color: '#a5d6ff' }}>&apos;LAOS block number:&apos;</span><span style={{ color: '#e6edf3' }}>, header.number.</span><span style={{ color: '#d2a8ff' }}>toNumber</span><span style={{ color: '#e6edf3' }}>());</span></div>
                    <div><span style={{ color: '#e6edf3' }}>console.</span><span style={{ color: '#d2a8ff' }}>log</span><span style={{ color: '#e6edf3' }}>(</span><span style={{ color: '#a5d6ff' }}>&apos;LAOS parent hash:&apos;</span><span style={{ color: '#e6edf3' }}>, header.parentHash.</span><span style={{ color: '#d2a8ff' }}>toHex</span><span style={{ color: '#e6edf3' }}>());</span></div>
                    <div><span style={{ color: '#e6edf3' }}>console.</span><span style={{ color: '#d2a8ff' }}>log</span><span style={{ color: '#e6edf3' }}>(</span><span style={{ color: '#a5d6ff' }}>&apos;LAOS state root:&apos;</span><span style={{ color: '#e6edf3' }}>, header.stateRoot.</span><span style={{ color: '#d2a8ff' }}>toHex</span><span style={{ color: '#e6edf3' }}>());</span></div>
                  </code></pre>
                </div>
              </div>

              {/* Call to action footer */}
              <p className="text-center font-bold text-white bg-red-700/50 rounded-md py-2 mt-2 tracking-wide">
                🔔 Act now — the future of LAOS is in the community&apos;s hands.
              </p>

            </div>
          </div>
        </div>

        <section className="mt-12 mb-14 w-full">
          <Slider {...settings}>
            {logos.map((logo, index) => (
              <div key={index} className="container">
                <img src={logo} alt="logo" />
              </div>
            ))}
          </Slider>
        </section>
        {/* <section className="my-10">
          <h2 className="section-title text-4xl mb-5 text-center">Assets Activity</h2>
          <hr className="w-[15%] h-[2px] my-4 mx-auto rounded border-0 hr-colored" />
          <AssetsMinted />
        </section>
        <section className="my-10">
          <h2 className="section-title text-4xl mb-5 text-center">Gas Savings Calculator</h2>
          <hr className="w-[15%] h-[2px] my-4 mx-auto rounded border-0 hr-colored" />
          <GasCalculator />
        </section> */}

        {/* <!-- USE CASES --> */}
        <section id="section-usecases">
          <UseCases />
        </section>
        {/* Skip out of container for full-width      */}
      </div>

      <section className="my-8">
        <div className="grid grid-cols-1 sm:grid-cols-5 py-4 space-y-8 sm:space-y-0 bg-fvlightgrey bg-opacity-10 justify-center place-items-center">
          <div className="section-title text-xl">Backed by</div>
          <div>
            <img src={logo_early} alt="Earlybird" />
          </div>
          <div>
            <img src={logo_target} alt="Target Global" />
          </div>
          <div>
            <img src={logo_adara} alt="Adara" />
          </div>
          <div>
            <img src={logo_4F} alt="4Founders" />
          </div>
        </div>
      </section>
      {/* Back into container */}
      <div className="container mx-auto px-10">
      </div>
      <div className="flex justify-center align-bottom polkadot h-40 md:h-60 lg:h-96 w-auto">
        <img
          className="object-scale-down object-bottom w-1/4 pb-10"
          src={logo_polka}
          alt="Polkadot"
        />
      </div>
      {/* <!-- BACK INTO CONTAINER --> */}
      <div className="container mx-auto px-10">
        <section className="mb-10">
          <div className="flex justify-center">
            <p className="w-3/4 text-center">
              LAOS is a fully open Layer 1 blockchain, decentralized via usage
              of its own native utility token, and deployed as a parachain
              within Polkadot. Built with the guidance of the Substrate Builders
              Program, LAOS inherits the security of the Polkadot ecosystem.
            </p>
          </div>
        </section>
        {/* <section id="section-roadmap" className="mb-20">
          <img
            className="sm:h-[100rem]  md:h-[130rem] lg:h-[150rem]  max-w-full mx-auto rounded-xl"
            src={roadmap}
            alt="roadmap"
          />
        </section> */}
        <section id="section-benefits" className="">
          <h2 className="section-title text-3xl md:text-4xl mb-5 mt-20 text-center">Benefits</h2>
          <hr className="w-[15%] h-[2px] my-4 rounded border-0 hr-colored mx-auto" />
          <div className="grid grid-cols-1 md:grid-cols-3  gap-3">
            <div className="bg-fvdarkpurple p-3 rounded-lg border-2 border-fvgreypurple">
              <img
                className="w-1/2"
                src={benefit_icon_scale}
                alt="Scalability"
              />
              <h3 className="text-2xl card-title text-fvorange w-3/4">
                Spend Less on Minting
              </h3>
              <p className="text-m">
                LAOS&apos;s minting fees are more than ten times lower than any
                other blockchain, yet assets still appear as regular NFTs in
                other chains. Save money without leaving the ecosystem of your
                choice.
              </p>
            </div>
            <div className="bg-fvdarkpurple p-3 rounded-lg border-2 border-fvgreypurple">
              <img
                className="w-1/2"
                src={benefit_icon_bridgeless}
                alt="Bridgeless"
              />
              <h3 className="text-2xl card-title text-fvorange w-3/4">
                Mint Assets in All Chains
              </h3>
              <p className="text-m">
                Seamless integration with all EVM chains from day one, and more
                to come in the future. Mint assets on other chains, such as
                Ethereum or Polygon,{" "}
                <span className="font-bold">without paying gas fees</span> for
                that chain
              </p>
            </div>
            <div className="bg-fvdarkpurple p-3 rounded-lg border-2 border-fvgreypurple">
              <img
                className="w-1/2"
                src={benefit_icon_interop}
                alt="Interoperability"
              />
              <h3 className="text-2xl card-title text-fvorange w-3/4">
                Cross-Application Utility
              </h3>
              <p className="text-m">
                Use LAOS{" "}
                <span className="font-bold">
                  Decentralized Asset Metadata Extension
                </span>{" "}
                to permissionlessly add new functionality to existing assets,
                enabling them to be used as desired in other applications or
                games.{" "}
              </p>
            </div>
          </div>
        </section>
      </div>
      <section>
        <PoweredByLAOS />
      </section>
      <div className="container mx-auto px-10">
        {/* VIDEOS */}
        <section id="bridgeless-minter" className="my-20">
          <EmbedVideo
            title="What is Bridgeless Minting"
            url="https://www.youtube.com/embed/rBEYpxq63tI?si=qJVaPV8io_gaHxum"
          />
        </section>
        {/* Signup */}

        {/* <!-- SKIP OUT OF CONTAINER FOR FULL_WIDTH IMAGE --> */}
      </div>
    </>
  );
};

export default Home;
